import http from "../components/http";
import { IComprador } from "../interfaces/comprador.interface";

const API_URL = '/compradores';

export const fetchCompradores = async (): Promise<IComprador[]> => {
  const response = await http.get(API_URL);
  return response.data;
};

export const createComprador = async (comprador: IComprador): Promise<IComprador> => {
  let response: any;

  try {
    response = await http.post(API_URL, comprador);
    return response.data;
  } catch (error) {
    console.log(error);
  }

  return response;
};

export const updateComprador = async (id: string, comprador: IComprador): Promise<IComprador> => {
  const response = await http.put(`${API_URL}/${id}`, comprador);
  return response.data;
};

export const deleteComprador = async (id: string): Promise<void> => {
  await http.delete(`${API_URL}/${id}`);
};
